<template>
	<div class="main-menu">
		<el-menu
			:default-active="activeIndex"
			class="main-menu-wrap"
			background-color="#111F30"
			text-color="#DEEDEE"
			:unique-opened="true"
			active-text-color="#fff"
			:collapse="true"
			@select="selectHandler">
			<el-menu-item index="1" class="main-menu-item el-submenu__title">
				<div class="menu-box">
					<div class="menu-box-icon menu-box-icon1"></div>
					<div class="menu-box-text" v-if="showMenu">首页</div>
				</div>
			</el-menu-item>
			<el-submenu index="2" class="main-menu-item" v-if="AuthorityList['01_0000_0000_00']">
				<template slot="title">
					<div class="menu-box">
						<div class="menu-box-icon menu-box-icon2"></div>
						<div class="menu-box-text" v-if="showMenu">卖家</div>
					</div>
					<span>卖家中心</span>
				</template>
				<div class="menu-child-box">
					<div class="menu-child-title">卖家</div>
					<el-menu-item index="2-1" v-if="AuthorityList['01_0002_0000_00']">企业设置</el-menu-item>
					<el-menu-item index="2-2" v-if="AuthorityList['01_0001_0000_00']">店铺设置</el-menu-item>
					<el-menu-item index="2-7" v-if="AuthorityList['01_0006_0000_00']">常购清单</el-menu-item>
					<el-menu-item index="2-3" v-if="AuthorityList['01_0004_0000_00']">员工管理</el-menu-item>
					<el-menu-item index="2-6" v-if="AuthorityList['01_0005_0000_00']">店铺分类</el-menu-item>
					<el-menu-item index="2-8" v-if="AuthorityList['01_0007_0000_00']">线路管理</el-menu-item>
					<el-menu-item index="2-4" v-if="AuthorityList['01_0003_0000_00']">运费</el-menu-item>
					<el-menu-item index="2-9" v-if="AuthorityList['01_0008_0000_00']">自提管理</el-menu-item>
					<el-menu-item index="2-10" v-if="AuthorityList['01_0009_0000_00']">微企付</el-menu-item>
				</div>
			</el-submenu>
			<el-submenu index="4" class="main-menu-item" v-if="AuthorityList['02_0000_0000_00']">
				<template slot="title">
					<div class="menu-box">
						<div class="menu-box-icon menu-box-icon3"></div>
						<div class="menu-box-text" v-if="showMenu">商品</div>
					</div>
					<span>商品中心</span>
				</template>
				<div class="menu-child-box">
					<div class="menu-child-title">商品</div>
					<!-- <el-menu-item index="4-1" v-if="AuthorityList['02_0001_0000_00']">商品档案</el-menu-item> -->
					<el-menu-item index="4-2" v-if="AuthorityList['02_0001_0000_00']">可售商品库</el-menu-item>
					<el-menu-item index="4-3" v-if="AuthorityList['02_0003_0000_00'] && !matchbillcenterflag">商品单位</el-menu-item>
					<el-menu-item index="4-4" v-if="AuthorityList['02_0004_0000_00']">附属商品</el-menu-item>
					<el-menu-item index="4-5" v-if="AuthorityList['02_0005_0000_00']">客户等级价格</el-menu-item>
				</div>
			</el-submenu>
			<el-submenu index="14" class="main-menu-item" v-if="AuthorityList['13_0000_0000_00'] && actualtimeinventoryflag === 0">
				<template slot="title">
					<div class="menu-box">
						<div class="menu-box-icon menu-box-icon4"></div>
						<div class="menu-box-text" v-if="showMenu">库存</div>
					</div>
					<span>库存中心</span>
				</template>
				<div class="menu-child-box">
					<div class="menu-child-title">库存</div>
					<el-menu-item index="14-1" v-if="AuthorityList['13_0001_0000_00']">出入库</el-menu-item>
					<el-menu-item index="14-2" v-if="AuthorityList['13_0002_0000_00']">库存查询</el-menu-item>
				</div>
			</el-submenu>
			<el-submenu index="5" class="main-menu-item" v-if="AuthorityList['03_0000_0000_00']">
				<template slot="title">
					<div class="menu-box">
						<div class="menu-box-icon menu-box-icon5"></div>
						<div class="menu-box-text" v-if="showMenu">客户</div>
					</div>
					<span>客户中心</span>
				</template>
				<div class="menu-child-box">
					<div class="menu-child-title">客户</div>
					<el-menu-item index="5-1" v-if="AuthorityList['03_0001_0000_00']">客户档案</el-menu-item>
					<!-- <el-menu-item index="5-3" v-if="AuthorityList['03_0002_0000_00']">用户审核</el-menu-item> -->
					<el-menu-item index="5-2">收货时间</el-menu-item>
					<el-menu-item index="5-3" v-if="AuthorityList['03_0004_0000_00']">商品专有价格</el-menu-item>
					<el-menu-item index="5-4" v-if="AuthorityList['03_0005_0000_00']">客户与私密商品关系</el-menu-item>
					<el-menu-item index="5-5" v-if="AuthorityList['03_0006_0000_00']">客户订货周期</el-menu-item>
					<!-- <el-menu-item index="5-4" v-if="AuthorityList['03_0003_0000_00']">营业时间</el-menu-item> -->
				</div>
			</el-submenu>
			<el-submenu index="8" class="main-menu-item" v-if="AuthorityList['04_0000_0000_00']">
				<template slot="title">
					<div class="menu-box">
						<div class="menu-box-icon menu-box-icon6"></div>
						<div class="menu-box-text" v-if="showMenu">支付</div>
					</div>
					<span>支付中心</span>
				</template>
				<div class="menu-child-box">
					<div class="menu-child-title">支付</div>
					<el-menu-item index="8-1" v-if="AuthorityList['04_0001_0000_00']">支付设置</el-menu-item>
					<el-menu-item index="8-2" v-if="AuthorityList['04_0002_0000_00']">预付货款</el-menu-item>
				</div>
			</el-submenu>
			<el-submenu index="6" class="main-menu-item" v-if="AuthorityList['07_0000_0000_00']">
				<template slot="title">
					<div class="menu-box">
						<div class="menu-box-icon menu-box-icon7"></div>
						<div class="menu-box-text" v-if="showMenu">订单</div>
					</div>
					<span>订单中心</span>
				</template>
				<div class="menu-child-box">
					<div class="menu-child-title">订单</div>
					<el-menu-item index="6-1" v-if="AuthorityList['07_0001_0000_00']">订单管理</el-menu-item>
					<el-menu-item index="6-3" v-if="AuthorityList['07_0003_0000_00']">代客下单</el-menu-item>
					<el-menu-item index="6-4" v-if="AuthorityList['07_0004_0000_00']">拣货清单</el-menu-item>
					<el-menu-item index="6-7" v-if="AuthorityList['07_0007_0000_00']">批量代客下单</el-menu-item>
					<el-menu-item index="6-2" v-if="AuthorityList['07_0002_0000_00']">退单管理</el-menu-item>
					<el-menu-item index="6-5" v-if="AuthorityList['07_0005_0000_00']">售后记录</el-menu-item>
					<el-menu-item index="6-6" v-if="AuthorityList['07_0006_0000_00']">代客退单</el-menu-item>
				</div>
			</el-submenu>
			<el-submenu index="13" class="main-menu-item" v-if="AuthorityList['11_0000_0000_00']">
				<template slot="title">
					<div class="menu-box">
						<div class="menu-box-icon menu-box-icon8"></div>
						<div class="menu-box-text" v-if="showMenu">销售</div>
					</div>
					<span>销售中心</span>
				</template>
				<div class="menu-child-box">
					<div class="menu-child-title">销售</div>
					<el-menu-item index="13-1" v-if="AuthorityList['11_0001_0000_00']">方案设置</el-menu-item>
					<el-menu-item index="13-2" v-if="AuthorityList['11_0002_0000_00']">提成统计</el-menu-item>
					<el-menu-item index="13-4" v-if="AuthorityList['11_0003_0000_00']">返佣统计</el-menu-item>
					<el-menu-item index="13-3" v-if="AuthorityList['11_0004_0000_00']">提现审核</el-menu-item>
				</div>
			</el-submenu>
			<el-submenu index="9" class="main-menu-item" v-if="AuthorityList['08_0000_0000_00']">
				<template slot="title">
					<div class="menu-box">
						<div class="menu-box-icon menu-box-icon9"></div>
						<div class="menu-box-text" v-if="showMenu">营销</div>
					</div>
					<span>营销中心</span>
				</template>
				<div class="menu-child-box">
					<div class="menu-child-title">营销</div>
					<el-menu-item index="9-1" v-if="AuthorityList['08_0001_0000_00']">全部活动</el-menu-item>
					<el-menu-item index="9-8" v-if="AuthorityList['08_0008_0000_00']">组合买赠</el-menu-item>
					<el-menu-item index="9-2" v-if="AuthorityList['08_0002_0000_00']">商品买赠</el-menu-item>
					<el-menu-item index="9-3" v-if="AuthorityList['08_0003_0000_00']">优惠券</el-menu-item>
					<el-menu-item index="9-4" v-if="AuthorityList['08_0004_0000_00']">商品预售</el-menu-item>
					<el-menu-item index="9-5" v-if="AuthorityList['08_0005_0000_00']">会员卡</el-menu-item>
					<el-menu-item index="9-6" v-if="AuthorityList['08_0007_0000_00']">商品折扣</el-menu-item>
				</div>
			</el-submenu>
			<el-submenu index="15" class="main-menu-item" v-if="AuthorityList['16_0000_0000_00']">
				<template slot="title">
					<div class="menu-box">
						<div class="menu-box-icon menu-box-icon15"></div>
						<div class="menu-box-text" v-if="showMenu">装修</div>
					</div>
					<span>店铺装修</span>
				</template>
				<div class="menu-child-box">
					<div class="menu-child-title">装修</div>
					<el-menu-item index="15-4" v-if="AuthorityList['16_0003_0000_00']">首页装修</el-menu-item>
					<el-menu-item index="15-1" v-if="AuthorityList['16_0004_0000_00']">采购装修</el-menu-item>
					<el-menu-item index="15-2" v-if="AuthorityList['16_0002_0000_00']">弹窗广告</el-menu-item>
					<!-- <el-menu-item index="15-5" v-if="AuthorityList['16_0005_0000_00']">我的装修</el-menu-item> -->
					<el-menu-item index="15-6" v-if="AuthorityList['16_0006_0000_00']">自定义页面</el-menu-item>
				</div>
			</el-submenu>
			<el-submenu index="3" class="main-menu-item" v-if="AuthorityList['05_0000_0000_00']">
				<template slot="title">
					<div class="menu-box">
						<div class="menu-box-icon menu-box-icon10"></div>
						<div class="menu-box-text" v-if="showMenu">权限</div>
					</div>
					<span>权限中心</span>
				</template>
				<div class="menu-child-box">
					<div class="menu-child-title">权限</div>
					<el-menu-item index="3-1" v-if="AuthorityList['05_0001_0000_00']">权限角色</el-menu-item>
				</div>
			</el-submenu>
			<el-menu-item index="10" class="main-menu-item el-submenu__title" v-if="AuthorityList['09_0000_0000_00']">
				<div class="menu-box">
					<div class="menu-box-icon menu-box-icon11"></div>
					<div class="menu-box-text" v-if="showMenu">报表</div>
				</div>
			</el-menu-item>
			<el-submenu index="7" class="main-menu-item" v-if="AuthorityList['06_0000_0000_00']">
				<template slot="title">
					<div class="menu-box">
						<div class="menu-box-icon menu-box-icon12"></div>
						<div class="menu-box-text" v-if="showMenu">系统</div>
					</div>
					<span>系统中心</span>
				</template>
				<div class="menu-child-box">
					<div class="menu-child-title">系统</div>
					<el-menu-item index="7-1" v-if="AuthorityList['06_0002_0000_00']">基础档案</el-menu-item>
					<el-menu-item index="7-2" v-if="AuthorityList['06_0001_0000_00']">订单设置</el-menu-item>
					<el-menu-item index="7-3" v-if="AuthorityList['06_0003_0000_00']">小程序</el-menu-item>
					<el-menu-item index="7-5" v-if="AuthorityList['06_0006_0000_00']">系统初始化</el-menu-item>
					<el-menu-item index="7-4" v-if="AuthorityList['06_0004_0000_00']">默认图管理</el-menu-item>
					<el-menu-item index="7-6" v-if="AuthorityList['06_0005_0000_00']">操作日志</el-menu-item>
				</div>
			</el-submenu>
			<el-submenu index="12" class="main-menu-item" v-if="AuthorityList['12_0000_0000_00']">
				<template slot="title">
					<div class="menu-box">
						<div class="menu-box-icon menu-box-icon13"></div>
						<div class="menu-box-text" v-if="showMenu">消息</div>
					</div>
					<span>消息中心</span>
				</template>
				<div class="menu-child-box">
					<div class="menu-child-title">消息</div>
					<el-menu-item index="12-1" v-if="AuthorityList['12_0001_0000_00']">交易消息</el-menu-item>
					<el-menu-item index="12-2" v-if="AuthorityList['12_0002_0000_00']">系统消息</el-menu-item>
				</div>
			</el-submenu>
		</el-menu>
	</div>
</template>
<script>
export default {
	name: 'MainMenu',
	props: {
		activeIndex: String,
		showMenu: Boolean
	},
	data () {
		return {
			matchbillcenterflag: false,
			isSettlement: window.sessionStorage.getItem('isSettlement'),
			isShow: true,
			AuthorityList: {
				'01_0000_0000_00': false,
				'02_0000_0000_00': false,
				'03_0000_0000_00': false,
				'04_0000_0000_00': false,
				'05_0000_0000_00': false,
				'06_0000_0000_00': false,
				'07_0000_0000_00': false,
				'01_0001_0000_00': false,
				'01_0002_0000_00': false,
				'01_0003_0000_00': false,
				'01_0004_0000_00': false,
				'01_0006_0000_00': false,
				'01_0007_0000_00': false,
				'01_0008_0000_00': false,
				'01_0009_0000_00': false,
				'02_0001_0000_00': false,
				'03_0001_0000_00': false,
				'03_0002_0000_00': false,
				'03_0003_0000_00': false,
				'04_0001_0000_00': false,
				'04_0002_0000_00': false,
				'05_0001_0000_00': false,
				'06_0001_0000_00': false,
				'06_0002_0000_00': false,
				'06_0003_0000_00': false,
				'06_0004_0000_00': false,
				'06_0005_0000_00': false,
				'07_0001_0000_00': false,
				'07_0002_0000_00': false,
				'07_0003_0000_00': false,
				'07_0004_0000_00': false,
				'07_0005_0000_00': false,
				'08_0000_0000_00': false,
				'08_0001_0000_00': false,
				'08_0002_0000_00': false,
				'09_0000_0000_00': false,
				'10_0000_0000_00': false,
				'10_0001_0000_00': false,
				'12_0000_0000_00': false,
				'12_0001_0000_00': false,
				'12_0002_0000_00': false,
				'13_0000_0000_00': false,
				'13_0001_0000_00': false,
				'13_0002_0000_00': false,
				'11_0000_0000_00': false,
				'11_0001_0000_00': false,
				'11_0002_0000_00': false,
				'16_0000_0000_00': false,
				'16_0001_0000_00': false,
				'16_0002_0000_00': false,
				'16_0003_0000_00': false,
				'16_0004_0000_00': false,
				'16_0005_0000_00': false
			},
			routeList: {
				'1': { path: 'home' },
				'2-1': { path: 'businessSetup' },
				'2-2': { path: 'storeBasicInfo' },
				'2-3': { path: 'personnelManage' },
				'2-4': { path: 'freight' },
				'2-6': { path: 'categoryManagement' },
				'2-7': { path: 'purchaseOrderSetting' },
				'2-8': { path: 'route' },
				'2-9': { path: 'selfDelivery' },
				'2-10': { path: 'weiPay' },
				'3-1': { path: 'permissions' },
				'4-1': { path: 'goodsManagement' },
				'4-2': { path: 'saleableGoods' },
				'4-3': { path: 'units' },
				'4-4': { path: 'appendageList' },
				'4-5': { path: 'gradePrice' },
				'5-3': { path: 'exclusivePrice' },
				'5-1': { path: 'customer' },
				'5-2': { path: 'receivingTime' },
				// '5-3': { path: 'examine' },
				'5-4': { path: 'customerAndProduct' },
				'5-5': { path: 'cusOrderScheme' },
				'6-1': { path: 'order' },
				'6-2': { path: 'refundOrder' },
				'6-3': { path: 'valetOrder' },
				'6-4': { path: 'pickingList' },
				'6-5': { path: 'afterSale' },
				'6-6': { path: 'valetRefundOrder' },
				'6-7': { path: 'batchValet' },
				'7-1': { path: 'fileSetting' },
				'7-2': { path: 'orderSetting' },
				'7-3': { path: 'miniProgram' },
				'7-4': { path: 'defaultImg' },
				'7-5': { path: 'initialize' },
				'7-6': { path: 'operationLog' },
				'8-1': { path: 'payCenter' },
				'8-2': { path: 'payAdvance' },
				'9-1': { path: 'marketing' },
				'9-2': { path: 'marketingManagement' },
				'9-8': { path: 'mutimarketingManagement' },
				'9-3': { path: 'discountList' },
				'9-4': { path: 'preSaleList' },
				'9-5': { path: 'vipList' },
				'9-6': { path: 'promotionList' },
				'10': { path: 'reportform/orderDetail', target: '_blank' },
				'11-1': { path: 'settlement' },
				'12-1': { path: 'msgCenter' },
				'12-2': { path: 'systemMsg' },
				'13-1': { path: 'percentage' },
				'13-2': { path: 'achievement' },
				'13-3': { path: 'withdrawalReview' },
				'13-4': { path: 'rebateStatistics' },
				'14-1': { path: 'storage' },
				'14-2': { path: 'inventoryCheck' },
				'15-1': { path: 'pageSettingList' },
				'15-2': { path: 'popupList' },
				'15-3': { path: 'themeSetting' },
				'15-4': { path: 'homepageList' },
				'15-5': { path: 'me' },
				'15-6': { path: 'customList' }
			},
			msgList: [],
			// clddock: 0,
			actualtimeinventoryflag: 0,
			matchbillcenterflag2: 0
		}
	},
	created () {
		this.$fxEventBus.$on('setMenu', (data) => {
			this.$emit('update:activeIndex', data)
		})
		this.$fxEventBus.$on('showInventory', (data) => {
			this.actualtimeinventoryflag = data
		})
		this.initUserAuthority()
		this.getClddock()
		this.checkSmallCategory()
	},
	methods: {
		checkSmallCategory () {
			// return new Promise((resolve, reject) => {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.matchbillcenterflag = res.matchbillcenterflag === 1
			})
			// })
		},
		getAuthority () {
			let params = {
				pId: ''
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
					// console.log(this.AuthorityList)
				}
			})
		},
		initUserAuthority () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/initUserAuthority`
			}).then(res => {
				if (res.result === true) {
					this.getAuthority()
				}
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		getClddock () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/get/organInfo`
			}).then(res => {
				// this.clddock = res.clddock
				this.matchbillcenterflag = res.matchbillcenterflag
				this.actualtimeinventoryflag = res.actualtimeinventoryflag
			}).catch(err => {
				this.$message.error(err.msg)
			})
		},
		selectHandler (index) {
			this.$emit('getMessage')
			this.$emit('update:activeIndex', index)
			let route = this.routeList[index]
			if (route.target === '_blank') {
				this.$fxGoBlank(`/${route.path}`, this.$router)
			} else {
				window.sessionStorage.removeItem('goodsParams')
				window.sessionStorage.removeItem('orderInfo')
				if (!((index === '6-1') && (this.activeIndex === '6-1' || this.activeIndex === '10'))) {
					window.sessionStorage.removeItem('tabInfo')
				}
				window.sessionStorage.removeItem('refundTab')
				window.sessionStorage.removeItem('endDate')
				window.sessionStorage.removeItem('startDate')
				window.sessionStorage.removeItem('orderSearchTime')
				window.sessionStorage.removeItem('shopInfo')
				window.sessionStorage.removeItem('goodsInfo')
				window.sessionStorage.removeItem('organid')
				window.sessionStorage.removeItem('customerSelect')
				window.sessionStorage.removeItem('orderSelect')
				window.sessionStorage.removeItem('refundOrderSelect')
				window.sessionStorage.removeItem('afterSelect')
				window.sessionStorage.removeItem('percentSelect')
				window.sessionStorage.removeItem('afterSearchTime')
				window.sessionStorage.removeItem('shopid')
				window.sessionStorage.removeItem('achieveDetailSelect')
				window.sessionStorage.removeItem('storageSelect')
				window.sessionStorage.removeItem('inventoryCheckSelect')
				window.sessionStorage.removeItem('marketid')
				window.sessionStorage.removeItem('payAdvanceSelect')
				window.sessionStorage.removeItem('withDrawalSelect')
				window.sessionStorage.removeItem('batchValetSelect')
				window.sessionStorage.removeItem('freightTab')
				window.sessionStorage.removeItem('freightSelect')
				window.sessionStorage.removeItem('freightTemplateSelect')
				window.sessionStorage.removeItem('pickListData')
				let _path = `/main/${route.path}`
				this.$router.push(_path)
			}
		}
	}
}
</script>
<style lang="stylus">
.main-menu {
	.el-menu--collapse {
		width: auto;
	}
	// .is-opened .el-submenu__title {
	// 	.menu-box:hover{
	// 		background-color: #173355 !important
	// 	}
	// }
	&.main-menu-style {
		.main-menu-item.is-active {
			// border-left: 4px solid var(--fx-primary-color) !important
			// color: var(--fx-primary-color) !important
			box-sizing: border-box;
			.menu-box {
				background-color: var(--fx-primary-color) !important
				border-radius: 4px;
				// width: calc(100% - 8px)!important;
				// margin: 0 4px;
			}
			.el-submenu__title {
				// background-color: var(--fx-primary-color) !important
			}
			.menu-box-text {
				// color: var(--fx-primary-color) !important
			}
			.menu-box-icon1 {
				background: url('~images/icon/menu-home-white.png') no-repeat 100%;
				background-size: 21px
			}
			.menu-box-icon2 {
				background: url('~images/icon/menu-seller-white.png') no-repeat 100%;
				background-size: 21px
			}
			.menu-box-icon3 {
				background: url('~images/icon/menu-product-white.png') no-repeat 100%;
				background-size: 21px
			}
			.menu-box-icon4 {
				background: url('~images/icon/menu-inventory-white.png') no-repeat 100%;
				background-size: 21px
			}
			.menu-box-icon5 {
				background: url('~images/icon/menu-custom-white.png') no-repeat 100%;
				background-size: 21px
			}
			.menu-box-icon6 {
				background: url('~images/icon/menu-pay-white.png') no-repeat 100%;
				background-size: 21px
			}
			.menu-box-icon7 {
				background: url('~images/icon/menu-order-white.png') no-repeat 100%;
				background-size: 21px
			}
			.menu-box-icon8 {
				background: url('~images/icon/menu-achieve-white.png') no-repeat 100%;
				background-size: 21px
			}
			.menu-box-icon9 {
				background: url('~images/icon/menu-market-white.png') no-repeat 100%;
				background-size: 21px
			}
			.menu-box-icon10 {
				background: url('~images/icon/menu-limit-white.png') no-repeat 100%;
				background-size: 21px
			}
			.menu-box-icon11 {
				background: url('~images/icon/menu-report-white.png') no-repeat 100%;
				background-size: 21px
			}
			.menu-box-icon12 {
				background: url('~images/icon/menu-system-white.png') no-repeat 100%;
				background-size: 21px
			}
			.menu-box-icon13 {
				background: url('~images/icon/menu-msg-white.png') no-repeat 100%;
				background-size: 21px
			}
			.menu-box-icon15 {
				background: url('~images/icon/store-draw-white.png') no-repeat 100%;
				background-size: 21px
			}
		}
	}
	.el-submenu__title {
		padding: 0!important
		height: 49px
		line-height: 49px
		background: #111F30!important;
		// &:hover, &:focus {
		// 	background: #111F30 !important
		// }
		.menu-box:hover{
			border-radius: 4px;
			background-color: #173355 !important
		}
	}
	.el-submenu__title .menu-box-text {
		color: #fff;
	}
	// .main-menu-wrap:not(.el-menu--collapse) {
	// 	width: 200px;
	// 	min-height: 400px;
	// }
	.menu-box {
		display: flex;
		align-items: center;
		justify-content: center;
		width: calc(100% - 8px)!important;
		margin: 0 4px;
		height: 100%;
		.menu-box-icon {
			display: inline-block;
			width: 21px;
			height: 21px
			&.menu-box-icon1 {
				background: url('~images/icon/menu-home-white.png') no-repeat 100%;
				background-size: 21px
			}
			&.menu-box-icon2 {
				background: url('~images/icon/menu-seller-white.png') no-repeat 100%;
				background-size: 21px
			}
			&.menu-box-icon3 {
				background: url('~images/icon/menu-product-white.png') no-repeat 100%;
				background-size: 21px
			}
			&.menu-box-icon4 {
				background: url('~images/icon/menu-inventory-white.png') no-repeat 100%;
				background-size: 21px
			}
			&.menu-box-icon5 {
				background: url('~images/icon/menu-custom-white.png') no-repeat 100%;
				background-size: 21px
			}
			&.menu-box-icon6 {
				background: url('~images/icon/menu-pay-white.png') no-repeat 100%;
				background-size: 21px
			}
			&.menu-box-icon7 {
				background: url('~images/icon/menu-order-white.png') no-repeat 100%;
				background-size: 21px
			}
			&.menu-box-icon8 {
				background: url('~images/icon/menu-achieve-white.png') no-repeat 100%;
				background-size: 21px
			}
			&.menu-box-icon9 {
				background: url('~images/icon/menu-market-white.png') no-repeat 100%;
				background-size: 21px
			}
			&.menu-box-icon10 {
				background: url('~images/icon/menu-limit-white.png') no-repeat 100%;
				background-size: 21px
			}
			&.menu-box-icon11 {
				background: url('~images/icon/menu-report-white.png') no-repeat 100%;
				background-size: 21px
			}
			&.menu-box-icon12 {
				background: url('~images/icon/menu-system-white.png') no-repeat 100%;
				background-size: 21px
			}
			&.menu-box-icon13 {
				background: url('~images/icon/menu-msg-white.png') no-repeat 100%;
				background-size: 21px
			}
			&.menu-box-icon15 {
				background: url('~images/icon/store-draw-white.png') no-repeat 100%;
				background-size: 21px
			}
		}
		.menu-box-text {
			display: inline-block;
			margin: 0 15px
		}
	}
}
.el-menu {
	backgournd: none;
	background-color: #fff !important
	padding: 0;
	margin-left: 0
}
.menu-child-box {
	width: 300px
	font-size: 14px;
	overflow: hidden;
	background: linear-gradient(-23deg, rgba(234, 241, 255, 0.52), rgba(255, 255, 255, 0.52));
	.menu-child-title{
		color: #333;
		font-weight: bold
		margin: 20px
	}
	li.el-menu-item {
		background-color: transparent!important
		border-left: 0!important
		width: 145px;
		display: inline-block;
		color: #595959!important;
		height: 18px;
		line-height: 18px;
		margin-bottom: 20px;
		&.is-active, &:hover {
			background: none!important
			color: var(--fx-primary-color) !important;
		}
	}
}
</style>
<style lang="stylus" scoped>
[class^='main-menu-icon'] {
	display: inline-block;
	margin-right: 10px;
	width: 20px;
	height: 20px;
	text-align: center;
	font-size: 18px;
	vertical-align: middle;
	background-repeat:no-repeat;
	background-position: center;
	background-size: cover
}
.main-menu-icon-home {
	background-image:url('')
}
.main-menu-icon-class {
	background-image:url('')
}
.main-menu-icon-merchant {
	background-image:url('')
}
.main-menu-icon-report {
	background-image:url('')
}
.main-menu-icon-setting {
	background-image:url('')
}
.main-menu-item {
	text-align:left
	border-left 2px solid #23272A !important
	li {
		background-color :#23272A !important
		padding-left: 70px !important
		padding-right: 0px !important
	}
}
// .el-menu-item{
// 	border-left 2px solid #23272A !important
// }
li.is-active{
	background-color :#23272A !important
	color: var(--fx-primary-color) !important

}
</style>
